import { UserPreferences } from 'models';
import { AnyAction } from 'redux';
import { userPreferencesTypes } from 'redux/actions/userPreferencesAction';

const defaultState = {
  userPreferences: {} as UserPreferences
};

const userPreferencesReducer = (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case userPreferencesTypes.GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        userPreferences: { ...action.data }
      };
    case userPreferencesTypes.UPDATE_USER_PREFERENCES:
      return {
        ...state,
        userPreferences: {
          ...state.userPreferences,
          preferences: { ...action.data },
        },
      };
    default:
      return state;
  }
};

export default userPreferencesReducer;
